<template>
    <div>
        <form @submit.prevent="validate">
            <div class="mb-3">
                <h5>Pharmacy Details</h5>
                <div class="form-group">
                    <label>Pharmacy Name</label>
                    <input type="text" name="companyName" data-vv-validate-on="blur" data-vv-as="pharmacy name" placeholder="Pharmacy Name"
                        v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('companyName')
                        }"
                        v-model="value.companyName">
                    <div v-show="validationErrors.has('companyName')" class="invalid-feedback">
                        {{ validationErrors.first('companyName') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Company Registration Number</label>
                    <input type="text" name="companyRegistrationNumber" data-vv-validate-on="blur" data-vv-as="company registration number"
                        :placeholder="`Enter your company registration number`" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('companyRegistrationNumber')
                        }"
                        v-model="value.companyRegistrationId">
                    <small>Example: 0123456789-X</small>

                    <div v-show="validationErrors.has('companyRegistrationNumber')" class="invalid-feedback">
                        {{ validationErrors.first('companyRegistrationNumber') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Contact Person</label>
                    <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                        placeholder="Contact Person" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('contactPerson')
                        }"
                        v-model="value.contactPerson">
                    <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                        {{ validationErrors.first('contactPerson') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Contact Person Email Address</label>
                    <input type="text" name="email" data-vv-validate-on="blur" data-vv-as="contact person email address" v-validate="'required|email'"
                        placeholder="Contact Person Email Address" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('email')
                        }"
                        v-model="value.emailAddress">

                    <div v-show="validationErrors.has('email')" class="invalid-feedback">
                        {{ validationErrors.first('email') }}
                    </div>
                    <small>Please use a company email address.</small>
                </div>

                <div class="form-group">
                    <label>Contact Person Phone Number</label>
                    <input type="text" name="phoneNumber" data-vv-validate-on="blur" data-vv-as="contact person phone number" placeholder="Contact Person Phone Number"
                        v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('phoneNumber')
                    }"
                        v-model="value.phoneNumber">
                    <div v-show="validationErrors.has('phoneNumber')" class="invalid-feedback">
                        {{ validationErrors.first('phoneNumber') }}
                    </div>
                </div>
                <div class="form-group">
                    <div class="mt-4 mb-2">
                        <b>Pharmacy Address</b>
                    </div>
                    <div class="form-group">
                        <label>Address Line 1</label>
                        <input type="text" name="addressLine1" data-vv-as="address line 1" data-vv-validate-on="blur"
                            placeholder="Address Line 1" v-model="value.addressLine1" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('addressLine1')
                        }">

                        <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                            {{ validationErrors.first('addressLine1') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Address Line 2</label>
                        <input type="text" class="form-control" placeholder="Address Line 2" v-model="value.addressLine2">
                    </div>

                    <div class="form-group">
                        <label>City</label>
                        <input type="text" name="city" data-vv-validate-on="blur" placeholder="City" v-model="value.addressCity"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('city')
                        }">
                        <div v-show="validationErrors.has('city')" class="invalid-feedback">
                            {{ validationErrors.first('city') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>State</label>
                        <select name="state" data-vv-validate-on="blur" v-model="value.addressState" v-validate="'required'"
                            :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('state')
                        }">
                            <option :value="null">Choose...</option>
                            <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                {{state.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('state')" class="invalid-feedback">
                            {{ validationErrors.first('state') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Postal Code</label>
                        <input type="text" name="postcode" placeholder="Postal Code" data-vv-validate-on="blur" v-model="value.addressPostcode"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('postcode')
                        }">
                        <div v-show="validationErrors.has('postcode')" class="invalid-feedback">
                            {{ validationErrors.first('postcode') }}
                        </div>
                    </div>
                </div>

                <div>
                    <div class="mt-4 mb-2">
                        <b>Bank Account Details</b>
                    </div>
                    <div class="form-group">
                        <label>Bank Name</label>
                        <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                            placeholder="Bank Name" v-model="value.bankName" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('bankName')
                        }">
                        <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                            {{ validationErrors.first('bankName') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Bank Account Number</label>
                        <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number"
                            placeholder="Bank Account Number" v-model="value.bankAccountNumber" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('bankAccountNumber')
                        }">
                        <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                            {{ validationErrors.first('bankAccountNumber') }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import malaysiaStates from '@/config/malaysiaStates';
export default {
    'name': 'RegisterPharmacyComponent',
    'props': {
        'value': Object
    },
    data () {
        return {
            malaysiaStates
        };
    },
    'methods': {
        validate () {
            return this.$validator.validateAll();
        }
    }
};
</script>
